/**
 * @owner @Appboy/intelligence
 */

import type { ComponentStoreData } from "./types";

const imageComponentName = "Image";

/** Returns whether the component store currently has an Image component configured. */
export const hasImageComponent = (componentStoreData: ComponentStoreData): boolean => {
  return Object.prototype.hasOwnProperty.call(componentStoreData.components ?? {}, imageComponentName);
};
